module.exports = __webpack_public_path__ + "img/image2.8976cf42.jpeg";